const { parseAsync } = require("json2csv");
let xlsx = require('json-as-xlsx')

/**
 * Run the process of creating the export report
 *
 * @param {object} school
 * @param {array} array
 * @param {array|null} version
 * @return void
 */
export async function downloadCSV(school, array, version = null, company = null) {
	let blob = '';
	let fn = filename(school, version);
	if(['A196152092', 'A1220263437'].includes(company) === false) {
		if (['A403998148', 'A173332977'].includes(company) === false) {
			let parsedInput = await parseAsync(array);
			blob = new Blob(["\ufeff", parsedInput]);
		} else {
			const keys = Object.keys(array[0]);
			const commaSeparatedString = [keys.join(",") , array.map(row => keys.map(key => row[key]).join(",")).join("\n")].join("\n")
			blob = new Blob([commaSeparatedString])
		}

		let url = URL.createObjectURL(blob);
		let downloadLink = document.createElement("a");

		downloadLink.href = url;
		downloadLink.download = `${fn}.csv`;

		document.body.appendChild(downloadLink);
		downloadLink.click();
		document.body.removeChild(downloadLink);
	} else {
		await exportToXls(array, fn);
	}	
}

/**
 * Run the query and concatenate all pages
 * of results.
 *
 * @callback query
 * @param {bool} timers
 * @return {array}
 */
export async function paginateQuery(query, timers = false) {
	let page = 1;
	let results = [];
	let finished = true;
	let timer = "Data Export Timer";

	timers && console.time(timer);

	do {
		const data = await query(page);

		finished = !data.length;
		results = results.concat(data);
		page++;

		timers && console.timeLog(timer);
	} while (!finished);

	timers && console.timeEnd(timer);

	console.log("Data Export Results:", results.length);

	return results;
}

/**
 * Generate the filename for the CSV download.
 *
 * @param {object} school
 * @param {string} version
 * @return {string}
 */
function filename(school, version) {
	const formattedDate = new Date().toLocaleDateString("en-GB");

	const prefix = version ? `${version}_` : "";

	return `${prefix}wonde_${school.name}_${formattedDate}`.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
}

/**
 * convert json to xls and save it.
 *
 * @param {object} data
 * @param {string} filename
 */

async function exportToXls(data, filename) {
	const headers = Object.keys(data[0]).map(element => {
		return {
			label: element,
			value: element
    	};
	});	

	let settings = {
		fileName: filename, 
		extraLength: 3, 
		writeOptions: {}
	}

	xlsx([{
		sheet: 'Sheet1',
		columns: headers,
		content: data
	}], settings)
}